var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-3 px-3 mb-3"},[_c('div',{staticClass:"d-flex align-center justify-space-between mb-3"},[_c('h4',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.labels.orderState')))])]),(_vm.order)?[_vm._v("\n    "+_vm._s(_vm.order.state.label[_vm.defaultLanguage])+"\n  ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }